import { render, staticRenderFns } from "./TheLogo.vue?vue&type=template&id=27ebb432&scoped=true&lang=pug"
import script from "./TheLogo.vue?vue&type=script&lang=ts"
export * from "./TheLogo.vue?vue&type=script&lang=ts"
import style0 from "./TheLogo.vue?vue&type=style&index=0&id=27ebb432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ebb432",
  null
  
)

export default component.exports